import { DashboardEditorProps } from "components/ComponentTypeTypes";

import { FC } from "react";
import { useCompanyTimezone, useDisplayTimezone } from "hooks/useTimezone";
import { LoadingTimeDisplayProps } from "../LoadingTimeDisplayTypes";


const LoadingTimeDisplayEditor: FC<DashboardEditorProps<LoadingTimeDisplayProps>> = (props) => {
  const displayTz = useDisplayTimezone();
  const companyTz = useCompanyTimezone();

  return null
};

export default LoadingTimeDisplayEditor;
